// extracted by mini-css-extract-plugin
export default {"container":"LeftContainer-module_container_vQJOK","task":"LeftContainer-module_task_kgEO0"};